/**
 * Dummy Mode Redux Slice
 * 
 * Manages dummy mode state across the application.
 * Dummy mode can be enabled via query parameter and persists across navigation.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DummyModeState {
  isDummyMode: boolean;
}

const initialState: DummyModeState = {
  isDummyMode: false,
};

const dummyModeSlice = createSlice({
  name: 'dummyMode',
  initialState,
  reducers: {
    setDummyMode: (state, action: PayloadAction<boolean>) => {
      state.isDummyMode = action.payload;
    },
    toggleDummyMode: (state) => {
      state.isDummyMode = !state.isDummyMode;
    },
  },
});

export const { setDummyMode, toggleDummyMode } = dummyModeSlice.actions;
export default dummyModeSlice.reducer;
